<template>
    <div class="game-background">
        <div class="loader-container" :class="{loading: loading}">
            <span class="loader-point"></span>
            <span class="loader-point"></span>
            <span class="loader-point"></span>
        </div>
       <div class="card" v-for="n in 16" :key="n" :ref="'card'+n"></div>
    </div>
</template>

<script>
export default {
  name: 'GameBackground',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      interval: null
    }
  },
  watch: {
    loading: {
      handler () {
        if (this.loading) {
          this.interval = window.requestAnimationFrame(this.animateCard)
        } else {
          window.cancelAnimationFrame(this.interval)
        }
      },
      immediate: true
    }
  },
  methods: {
    getRandom (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    animateCard () {
      const card = this.$refs[`card${this.getRandom(1, 16)}`]
      card[0].style.opacity = this.getRandom(3, 10) / 10
      this.interval = requestAnimationFrame(this.animateCard)
      //   setTimeout(() => {
      //     console.log('animate')

    //     const card = this.$refs[`card${this.getRandom(1, 16)}`]
    //     card[0].style.opacity = this.getRandom(3, 10) / 10
    //     this.interval = requestAnimationFrame(this.animateCard)
    //   }, 50)
    }
  },
  mounted () {
    for (const key in this.$refs) {
      if (this.$refs.hasOwnProperty(key)) {
        const card = this.$refs[key]
        card[0].style.opacity = this.getRandom(3, 10) / 10
      }
    }
  }
}
</script>

<style lang="scss" scoped>
     @import "../assets/styles/variables";

    $cardMap: (
      401px: 100px,
      801px: 140px,
      1400px: 200px,
    );

    $card: 80px;
    $cardGrid: 4;
    .game-background{
        position: absolute;
        height: $card * $cardGrid;
        width: $card * $cardGrid;
    }
    .loader-container{
        display: inline-block;
        position:absolute;
        z-index: 10;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .loader-point{
            display: none;
            height: 16px;
            width: 16px;
            border-radius: 8px;
            margin: 12px;
            background: $game-primary;

        }
        &.loading{
            .loader-point{
                display: inline-block;
                animation: pulse 600ms ease-in-out 0ms infinite;
                opacity: 0;
                transform: scale(0);
                &:nth-child(2){
                    animation-delay: 200ms;
                }
                &:nth-child(3){
                    animation-delay: 400ms;
                }
            }
        }
    }

    .card{
        width: $card;
        height: $card;
        background-size: $card * $cardGrid;
        position: absolute;
        transition: all .25s ease-in-out;
        @for $i from 1 through $cardGrid {
             @for $j from 1 through $cardGrid {
                &:nth-child(#{$cardGrid * ($i - 1) + $j}){
                    background: #dddddd;
                    left: $card * ($i - 1);
                    top: $card * ($j - 1)
                }
             }
        }

    }

@each $size, $cardSize in $cardMap {
  @media screen and (min-width: $size){
    $card: $cardSize;
    .game-background{
        height: $card * $cardGrid;
        width: $card * $cardGrid;
    }
    .card{
        width: $card;
        height: $card;
        background-size:  $card * $cardGrid;
        @for $i from 1 through $cardGrid {
          @for $j from 1 through $cardGrid {
            &:nth-child(#{$cardGrid * ($i - 1) + $j}){
                background: #dddddd;
                left: $card * ($i - 1);
                top: $card * ($j - 1)
            }
          }
        }
    }
  }
}

@keyframes pulse {
    0%{
        opacity: 0;
        transform: scale(0);
    }
    50%{
        opacity: 1;
        transform: scale(1);
    }
    75%{
        opacity: 0;
    }

    100%{
        opacity: 0;
        transform: scale(0);
    }
}
</style>
